import Vue from 'vue';
import VueRouter from 'vue-router';

import Login from '../components/Login.vue';
import AdminNav from '../components/AdminNav.vue';
import UserNav from '../components/UserNav.vue';
import ProjectSquare from '../components/admin/ProjectSquare.vue';
import RevenueList from '../components/admin/RevenueList.vue';
import TaskManage from '../components/admin/TaskManage.vue';
import UserManage from '../components/admin/UserManage.vue';

import UserProjectSquare from '../components/user/UserProjectSquare.vue';
import UserRevenueList from '../components/user/UserRevenueList.vue';
import MyTask from '../components/user/MyTask.vue';
import MarkingTable from '../components/user/MarkingTable.vue';

import { sessionData } from "../storage/storage";

Vue.use(VueRouter)
const routes = [
  { path: '/', redirect: '/Login' },
  { path: '/Login', component: Login },
  { path: '/AdminNav', 
    component: AdminNav,
    children: [
      { 
        path: '/', 
        redirect: 'TaskManage', 
      },
      { 
        path: '/AdminNav/ProjectSquare', 
        component: ProjectSquare, 
        meta: {
          requireAuth: true,  
          roles: ['MANAGER']
        }  
      },
      { 
        path: '/AdminNav/RevenueList', 
        component: RevenueList, 
        meta: {
          requireAuth: true,  
          roles: ['MANAGER']
        }  
      },
      {
        path: '/AdminNav/TaskManage', 
        component: TaskManage, 
        meta: {
          requireAuth: true,  
          roles: ['MANAGER']
        }  
      },
      { 
        path: '/AdminNav/UserManage', 
        component: UserManage, 
        meta: {
          requireAuth: true,  
          roles: ['MANAGER']
        }  
      },
    ]
  },
  {
    path: 'UserNav',
    component: UserNav,
    children: [
      { 
        path: '/', 
        redirect: 'MyTask', 
      },
      { 
        path: '/UserNav/MyTask', 
        component: MyTask, 
        meta: {
          requireAuth: true,  
          roles: ['MARKER']
        }  
      },
      { 
        path: '/UserNav/UserProjectSquare', 
        component: UserProjectSquare, 
        meta: {
          requireAuth: true,  
          roles: ['MARKER']
        }  
      },
      { 
        path: '/UserNav/UserRevenueList', 
        component: UserRevenueList, 
        meta: {
          requireAuth: true,  
          roles: ['MARKER']
        }  
      },
      { 
        path: '/UserNav/MarkingTable', 
        component: MarkingTable,
        meta: {
          requireAuth: true,  
          roles: ['MARKER']
        }  
      },
    ]
  }
]
const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    if (sessionData('get','token')) {
      next();
    } else {
      next('/login')
    }
  }else {
    next();
  }
});
export default router;
